<script lang="ts">
	import type { Insert } from "$lib/def/seo/insert";

	import { getCimgUrl } from "$lib/serv/admin/editImg";

	export let item: Insert | undefined;
	export let cta: { text: string, action: (() => void) | string, newTab?: boolean } | null = null;


</script>

<article class="business-item">
	<div>
		<img src={getCimgUrl(item?.icon ?? item?.image)} alt="alt">
	</div>
	<h4 class="headline-m">{item?.title}</h4>
	<p class="body-l">{item?.subtitle}</p>
	{#if cta}
		{#if typeof cta.action === 'string'}
			<a class="button secondary medium" href={cta.action} target={cta.newTab ? '_blank' : '_self'}>{cta.text}</a>
		{:else}
			<button class="button secondary medium" on:click={cta.action}>{cta.text}</button>
		{/if}
	{/if}
</article>

<style lang="scss">
	@use 'color';
	@use 'screen';

	.business-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		max-width: 310px;
		@media(screen.$mdl) { max-width: 330px; }
		div {
			position: relative;
			width: 150px;
			height: 150px;
			@media(screen.$mdl) {
				width: 172px;
				height: 172px;
			}
			img {
				position: absolute;
				bottom: 4px;
				left: 4px;
				width: calc(100% - 8px);
				height: calc(100% - 8px);
				object-fit: contain;
			}
		}
		h4 { 
			margin: 0.4rem 0 0.6rem 0;
			@media(screen.$mdl) { margin: 1rem 0 0.6rem 0; }
		}
		p {
			color: color.$on-background-medium-importance;
			margin: 0 0 1.3rem 0;
		}
	}
</style>